export default __webpack_public_path__ + "static/media/Z_Ziper.349d7b94.svg";